import {
    useDownloadLinkQuery as useDownloadLinkV2Query,
    useUploadLinkMutation as useUploadLinkV2Mutation,
} from '#api/documentLinkApi.slice.ts';
import type { RTKQueryOptions } from '#api-bridge/utils/rktQuery.utils.ts';
import type { DocumentFileLink } from '#domain/Document.ts';

type QueryArgs = { documentId: string; fileName: string; fileId?: string };

export const useDownloadLinkQuery = (arg: QueryArgs, options?: RTKQueryOptions) => {
    return useDownloadLinkV2Query({ documentId: arg.fileId ?? arg.documentId, fileName: arg.fileName }, options);
};

export const useUploadLinkMutation = () => {
    const [uploadV2, resultV2] = useUploadLinkV2Mutation();

    const uploadLink = (arg: QueryArgs) => {
        return uploadV2({ documentId: arg.fileId ?? arg.documentId, fileName: arg.fileName });
    };

    return [uploadLink, resultV2] as const;
};

export type { DocumentFileLink };
